<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="300"
    :title="t('网络限速')"
    alignCenter
    @close="handleClose"
  >
    <el-form ref="formRef" :model="formData" :rules="rules">
      <el-form-item label="上行限速" prop="upLink">
        <el-input type="text" v-model="formData.upLink" placeholder="请输入网速" required />
      </el-form-item>
      <el-form-item label="下行限速" prop="downLink">
        <el-input v-model="formData.downLink" placeholder="请输入网速"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button type="primary" :loading="loading" :disabled="loading" @click="submitForm">提交</el-button>
    </div>
  </ComDialog>
</template>
<script setup>
import { ref, defineExpose, defineEmits, nextTick } from "vue";
import ComDialog from "@/components/comDialog/index.vue";
import { useI18n } from "vue-i18n";
import request from "@/utils/request.ts";
import API_CONFIG from "../api.json";
import { ElMessage } from "element-plus";
const emit = defineEmits(["freshLoad"]);
const loading = ref(false);
const { t } = useI18n();
const dialogVisible = ref(false);
const formRef = ref(null);
const currentData = ref([]);
const formData = ref({
  upLink: 0,
  downLink: 0
});
const rules = ref({
  upLink: [{ required: true, message: "请输入上行限速", trigger: "blur" }],
  downLink: [{ required: true, message: "请输入下行限速", trigger: "blur" }]
});

const open = data => {
  dialogVisible.value = true;
  currentData.value = data;
  formData.value = { upLink: 100, downLink: 0 };
  nextTick(() => {
    formRef.value.clearValidate();
  });
};

const handleClose = () => {
  dialogVisible.value = false;
};

const submitForm = async () => {
  const valid = await formRef.value.validate();
  if (!valid) return;
  loading.value = true;
  request
    .post(API_CONFIG.limitSpeed.url, {
      ctrAliaList: currentData.value.map(ele => ele.code),
      downLink:Number(formData.value.downLink),
      upLink:Number(formData.value.upLink)
    })
    .then(res => {
      if (res.code == 0) {
        // ElMessage.success("限速成功");
        const result = res.data[0]
        emit("freshLoad");
        dialogVisible.value = false;
      } else {
        ElMessage.error(res.msg);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

defineExpose({ open });
</script>
<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}
</style>